<script setup>
import { ref, computed } from 'vue'
import { register } from 'swiper/element/bundle'
import { Autoplay } from 'swiper/modules'
import { useGlobalStore } from '@stores/global'
import Testimonial from '@components/global/accents/Testimonial.vue'

register()

const global = useGlobalStore()

const creativeEffect = computed(() => {
	const width = global.screenWidth

	if (width < 1024) {
		return {
			limitProgress: 2,
			prev: {
				translate: ['-100%', '-100%', 0],
				rotate: [5, 5, 10],
			},
			next: {
				translate: ['75%', '75%', 0],
				rotate: [-3, -3, -10],
			},
		}
	}
	if (width < 1280) {
		return {
			limitProgress: 2,
			prev: {
				translate: ['-90%', '-90%', 0],
				rotate: [5, 5, 10],
			},
			next: {
				translate: ['75%', '75%', 0],
				rotate: [-3, -3, -10],
			},
		}
	}

	if (width < 1536) {
		return {
			limitProgress: 2,
			prev: {
				translate: ['-85%', '-85%', 0],
				rotate: [7, 7, 15],
			},
			next: {
				translate: ['75%', '75%', 0],
				rotate: [-4, -4, -15],
			},
		}
	}

	return {
		limitProgress: 2,
		prev: {
			translate: ['-67.5%', '-67.5%', 0],
			rotate: [10, 10, 20],
		},
		next: {
			translate: ['67.5%', '67.5%', 0],
			rotate: [-5, -5, -20],
		},
	}
})

const swiper = ref(null)
const currentIndex = ref(0)
const autoplayProgress = ref(0)

function onSlideChange(event) {
	currentIndex.value = event.detail[0].realIndex
}

function onAutoplayTimeLeft(event) {
	autoplayProgress.value = 1 - event.detail[2]
}

function next() {
	if (swiper.value?.swiper) {
		swiper.value.swiper.slideNext()
	}
}

function previous() {
	if (swiper.value?.swiper) {
		swiper.value.swiper.slidePrev()
	}
}
</script>

<template>
	<section class="relative bg-gradient-to-r from-crowns-off-black via-crowns-dark-grey to-crowns-off-black" v-if="global.testimonials.length > 0">
		<swiper-container
			ref="swiper"
			:key="creativeEffect"
			class="overflow-visible"
			effect="creative"
			grab-cursor="true"
			:modules="[Autoplay]"
			:loop="true"
			:autoplay="{
				delay: 5000,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
			}"
			:creativeEffect="creativeEffect"
			@swiperactiveindexchange="onSlideChange"
			@swiperautoplaytimeleft="onAutoplayTimeLeft">
			<swiper-slide class="w-full overflow-visible py-32" v-for="(testimonial, index) in global.testimonials">
				<div class="container flex justify-center">
					<div class="w-full lg:w-4/5 2xl:w-3/5">
						<Testimonial :testimonial="testimonial" :current="currentIndex === index" />
					</div>
				</div>
			</swiper-slide>
			<div class="absolute bottom-16 left-1/2 z-40 flex h-8 w-fit -translate-x-1/2 touch-manipulation">
				<button class="group w-8 rounded-l-full border-2 border-r-0 border-crowns-off-white bg-black" @click="previous" aria-label="Previous Testimonial">
					<i class="fa-chisel fa-solid fa-arrow-left translate-x-0.5 transition-all duration-200 ease-in-out group-hover:translate-x-0" />
				</button>
				<div class="flex w-20 items-center border-2 border-crowns-off-white bg-black px-2">
					<div class="h-[1px] w-full bg-crowns-off-white/40">
						<div class="h-[1px] bg-crowns-off-white" :style="{ width: `${autoplayProgress * 100}%` }" />
					</div>
				</div>
				<button class="x group w-8 rounded-r-full border-2 border-l-0 border-crowns-off-white bg-black" @click="next" aria-label="Next Testimonial">
					<i class="fa-chisel fa-solid fa-arrow-right -translate-x-0.5 transition-all duration-200 ease-in-out group-hover:translate-x-0" />
				</button>
			</div>
		</swiper-container>
	</section>
</template>
